function changeSelectColorForm() {
  const isNewForm = $(".newForm");
  if (isNewForm) {
    $("select").on("change", function () {
      var selected_v = this.value;
      if (selected_v) {
        $(this).css("color", "black");
      }
    });
  }
}

export default changeSelectColorForm;
